(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxDateTimePicker
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-date-time-picker - it's a control for setting date and time or just date.
	 *
	 * @param {object} ngModel - Binds model date value to control.
	 * @param {string} displayMode - If `displayMode` is `"full"` (by default) then control will display Date and Time, if `"date"` - then just Date, if `"time"` - then just Time.
	 * @param {string} label@ - Defines label displayed on the form
	 * @param {boolean} ngRequired= - The required property sets or returns whether a mxDateTimePicker must be filled out before submitting a form.
	 * @param {boolean} disabled= - The disabled property sets or returns whether a mxDateTimePicker should be disabled, or not.
	 * @param {boolean} readOnly= - The readOnly property sets or returns whether the contents of a mxDateTimePicker should be read-only.
	 * @param {string} minDate= - Min date.
	 * @param {string} maxDate= - Max date.
	 *
	 * @usage `<mx-date-time-picker ng-model="vm.myDate"></mx-date-time-picker>`
	 *
	 */
	angular.module('mx.components').directive('mxDateTimePicker', function mxDateTimePickerDirective() {
		var directive = new mx.components.FormControlBase(MxDateTimeCtrl, 'mx-date-time-picker/mx-date-time.html');
		angular.extend(directive.bindToController, {
			minDate: '<',
			maxDate: '<',
			displayMode: '@',
			isoString: '@',
			onBlur: '<',
		});
		return directive;
	});

	MxDateTimeCtrl.$inject = ['mx.app.DeviceService', '$timeout', '$scope', 'mx.internationalization', '$mdDateLocale', '$element'];

	function MxDateTimeCtrl(DeviceService, $timeout, $scope, mxI18n, $mdDateLocale, $element) {
		var vm = this;
		var _value;

		vm._formatWithZero = _formatWithZero;

		vm.$onInit = function () {
			vm.displayMode = vm.displayMode || 'full';
			vm.isoString = vm.isoString && vm.isoString.toLowerCase() !== 'false';
			vm.minDate = vm.minDate ? new Date(vm.minDate) : vm.minDate;
			vm.maxDate = vm.maxDate ? new Date(vm.maxDate) : vm.maxDate;
			vm.DeviceService = DeviceService;

			var dateFormats = mxI18n.getLocale().DATETIME_FORMATS;

			vm.ampmMode = dateFormats.shortTime.indexOf('a') !== -1;
			$mdDateLocale.firstDayOfWeek = (dateFormats.FIRSTDAYOFWEEK !== null ? dateFormats.FIRSTDAYOFWEEK : 6) + (1 % 7);

			Object.defineProperty(vm, 'value', {
				get: function () {
					if (typeof _value === 'undefined') {
						_value = null;
					}
					// Round to minutes
					if (_value && _value.setMilliseconds) {
						_value.setSeconds(0, 0);
					}
					return _value;
				},
				set: function (value) {
					setModel(value);
				},
			});

			vm.placeholder = mxI18n.getDateFormatString();

			mx.components.FormControlControllerBase.call(vm, $timeout);

			if (vm.model) {
				vm.value = new Date(vm.model);
			}
		};

		vm.$postLink = function () {
			$element.on('blur', '.md-datepicker-input', function (ev) {
				ev.target.value = mx.components.Utils.convertDateFrom6or8Digits(ev.target.value);
			});

			setTimeout(() => {
				vm.setHintHandlers($element.find('select, input, [tabindex=0], button'));
			});
		};

		// for the case when model is updated outside after awhile
		$scope.$watch('vm.model', function () {
			var newDate = new Date(vm.model);
			var newHours = newDate.getHours();
			if (
				vm.model &&
				(typeof vm.hours === 'undefined' ||
					vm.hours === null ||
					isNaN(vm.hours) ||
					typeof vm.minutes === 'undefined' ||
					vm.minutes === null ||
					isNaN(vm.minutes) ||
					vm.minutes !== newDate.getMinutes() ||
					(vm.ampmMode && vm.isPM !== newHours >= 12) ||
					vm.hours !== _getHoursConsideringAMPM(newHours))
			) {
				vm.value = new Date(vm.model);
			}
		});

		$scope.$watch('vm.hours', function (newHours, oldHours) {
			if (newHours !== oldHours) {
				var minutesWasSet = vm.minutes !== undefined;
				_value = _prepareValue();
				var hoursToBeSet = newHours;
				if (vm.ampmMode && vm.isPM) {
					hoursToBeSet += 12;
				}
				_value.setHours(hoursToBeSet);
				if (!minutesWasSet) {
					var _tempVal = new Date(_value);
					_tempVal.setMinutes(0);
					if (_tempVal >= vm.minDate || _tempVal <= vm.maxDate) {
						_value.setMinutes(0);
					}
				}
				setModel(_value);
			}
		});

		$scope.$watch('vm.minutes', function (newMinutes, oldMinutes) {
			if (newMinutes !== oldMinutes) {
				_value = _prepareValue();
				_value.setMinutes(newMinutes);
				setModel(_value);
			}
		});

		$scope.$watch('vm.isPM', function (newIsPM, oldIsPM) {
			if (vm.ampmMode && newIsPM !== oldIsPM) {
				_value = _prepareValue();
				var _hours = _value.getHours();
				if ((newIsPM && _hours < 12) || (!newIsPM && _hours >= 12)) {
					_value.setHours(newIsPM ? _hours + 12 : _hours - 12);
					setModel(_value);
				}
			}
		});

		function setModel(value) {
			if (vm.minDate && vm.minDate instanceof Date && value instanceof Date && vm.minDate > value) {
				value = new Date(vm.minDate);
			}
			if (vm.maxDate && vm.maxDate instanceof Date && value instanceof Date && vm.maxDate < value) {
				value = new Date(vm.maxDate);
			}
			_value = value;
			vm.model = vm.isoString && value ? value.toISOString() : value;
			setTimeVars(_value);
		}

		function setTimeVars(time) {
			if (time) {
				var _hours = time.getHours();
				vm.isPM = _hours >= 12;
				vm.hours = _getHoursConsideringAMPM(_hours);
				vm.minutes = time.getMinutes();
			}
		}

		function _prepareValue() {
			if (!_value) {
				var newVal = new Date();
				newVal.setHours(0);
				newVal.setMinutes(0);
				newVal.setSeconds(0, 0);
				setModel(newVal);
			}
			return _value;
		}

		function _getHoursConsideringAMPM(hours24) {
			// in AM/PM mode if vm.hours === 0 it means `12` for easier calculations
			return vm.ampmMode ? hours24 % 12 : hours24;
		}

		function _formatWithZero(val) {
			return (val < 10 ? '0' : '') + val;
		}

		this.onValueChanging = function (newVal) {
			_value = (typeof newVal === 'string' && vm.isoString) || newVal instanceof Date ? new Date(newVal) : newVal;
			return newVal;
		};

		$scope.$watch('vm.minDate', function () {
			if (vm.minDate && typeof vm.minDate === 'string') {
				vm.minDate = new Date(vm.minDate);
			}
		});
		$scope.$watch('vm.maxDate', function () {
			if (vm.maxDate && typeof vm.maxDate === 'string') {
				vm.maxDate = new Date(vm.maxDate);
			}
		});
	}
})(window);
